import React from 'react';
import { content, SupportedLocale } from '../lib/content';

type SpecialisationsProps = {
  locale?: SupportedLocale;
};

export const Specialisations: React.FC<SpecialisationsProps> = ({
  locale = 'pl',
}) => {
  const t = content[locale].specialisations;

  return (
    <section id={t.id} className="specialisations reveal">
      <div className="container">
        <div className="section-heading">
          <h2>{t.title}</h2>
        </div>
        <p className="section-intro">{t.intro}</p>
        <div className="specialisations-grid">
          {t.items.map((item) => (
            <div className="card special-card" key={item.title}>
              <h3>{item.title}</h3>
                          <p className="special-card__desc">{item.description}</p>

{item.linkLabel && item.linkHref && (
  <a className="special-card__link" href={item.linkHref}>
    {item.linkLabel}
  </a>
)}

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
